var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "mt-2" },
    [
      _c("OutOfOfficeFunctionbox", {
        attrs: { functionbox_uuid: _vm.functionbox_uuid },
      }),
      _c("InboxFilter", {
        attrs: { amount: 2, filterName: "READ" },
        model: {
          value: _vm.filter_read,
          callback: function ($$v) {
            _vm.filter_read = $$v
          },
          expression: "filter_read",
        },
      }),
      _vm.functionbox_uuid != ""
        ? _c(
            "span",
            [
              _c("InboxFilter", {
                attrs: { amount: 3, filterName: "ASSIGNED" },
                model: {
                  value: _vm.filter_assigned,
                  callback: function ($$v) {
                    _vm.filter_assigned = $$v
                  },
                  expression: "filter_assigned",
                },
              }),
              _c("InboxFilter", {
                attrs: { amount: 2, filterName: "STATUS" },
                model: {
                  value: _vm.filter_status,
                  callback: function ($$v) {
                    _vm.filter_status = $$v
                  },
                  expression: "filter_status",
                },
              }),
              _vm.issue_status.length != 0
                ? _c(
                    "span",
                    [
                      _c("InboxFilterIssueStatus", {
                        attrs: {
                          amount: _vm.issue_status.length,
                          filterName: "ISSUE_STATUS",
                          items: _vm.issue_status,
                        },
                        model: {
                          value: _vm.filter_issue_status,
                          callback: function ($$v) {
                            _vm.filter_issue_status = $$v
                          },
                          expression: "filter_issue_status",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm.functionbox_uuid == ""
        ? _c(
            "span",
            [
              _c("InboxFilter", {
                attrs: { amount: 2, filterName: "ARCHIVED" },
                model: {
                  value: _vm.filter_archived,
                  callback: function ($$v) {
                    _vm.filter_archived = $$v
                  },
                  expression: "filter_archived",
                },
              }),
              _vm.issue_status.length != 0
                ? _c(
                    "span",
                    [
                      _c("InboxFilterIssueStatus", {
                        attrs: {
                          amount: _vm.issue_status.length,
                          filterName: "MESSAGE_STATUS",
                          items: _vm.issue_status,
                        },
                        model: {
                          value: _vm.filter_issue_status,
                          callback: function ($$v) {
                            _vm.filter_issue_status = $$v
                          },
                          expression: "filter_issue_status",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm.showFilterClearAll
        ? _c(
            "b-button",
            {
              staticClass: "no-border",
              attrs: { size: "sm" },
              on: { click: _vm.clearFilterAll },
            },
            [_vm._v(_vm._s(_vm.$t("FILTER.CLEAR")))]
          )
        : _vm._e(),
      _vm.hasBulk
        ? _c(
            "div",
            { staticClass: "hidden-not-mobile pb-1" },
            [
              _vm.items.length != 0
                ? _c("b-form-checkbox", {
                    on: { change: _vm.updateAll },
                    model: {
                      value: _vm.update_all,
                      callback: function ($$v) {
                        _vm.update_all = $$v
                      },
                      expression: "update_all",
                    },
                  })
                : _vm._e(),
              _vm.selected.length != 0
                ? _c(
                    "span",
                    [
                      _vm.hasRemoveEnabled
                        ? _c(
                            "b-button",
                            {
                              staticClass: "float-right",
                              attrs: {
                                variant: "danger",
                                size: "sm",
                                title: _vm.$t("REMOVE"),
                              },
                              on: { click: _vm.removeMessages },
                            },
                            [_vm._v(_vm._s(_vm.$t("REMOVE")))]
                          )
                        : _vm._e(),
                      _vm.hasAssignOtherEnabled && _vm.functionbox_uuid != ""
                        ? _c("FunctionboxAssignUsers", {
                            attrs: {
                              functionbox_uuid: _vm.functionbox_uuid,
                              selected: _vm.selected,
                              size: "sm",
                            },
                            on: { assigned: _vm.AssignedMessages },
                          })
                        : _vm._e(),
                      _vm.hasAssignOtherEnabled &&
                      _vm.functionbox_uuid != "" &&
                      _vm.hasClaimed
                        ? _c("FunctionboxAssignUsers", {
                            attrs: {
                              functionbox_uuid: _vm.functionbox_uuid,
                              selected: _vm.selected,
                              size: "sm",
                              action: "clear",
                            },
                            on: { assigned: _vm.AssignedMessages },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm.selected.length != 0 && _vm.hasBulk
        ? _c(
            "span",
            { staticClass: "hidden-mobile" },
            [
              _vm.hasRemoveEnabled
                ? _c(
                    "b-button",
                    {
                      staticClass: "float-right",
                      attrs: {
                        variant: "danger",
                        size: "sm",
                        title: _vm.$t("REMOVE"),
                      },
                      on: { click: _vm.removeMessages },
                    },
                    [_vm._v(_vm._s(_vm.$t("REMOVE")))]
                  )
                : _vm._e(),
              _vm.hasAssignOtherEnabled && _vm.functionbox_uuid != ""
                ? _c("FunctionboxAssignUsers", {
                    attrs: {
                      functionbox_uuid: _vm.functionbox_uuid,
                      selected: _vm.selected,
                      size: "sm",
                    },
                    on: { assigned: _vm.AssignedMessages },
                  })
                : _vm._e(),
              _vm.hasAssignOtherEnabled &&
              _vm.functionbox_uuid != "" &&
              _vm.hasClaimed
                ? _c("FunctionboxAssignUsers", {
                    attrs: {
                      functionbox_uuid: _vm.functionbox_uuid,
                      selected: _vm.selected,
                      size: "sm",
                      action: "clear",
                    },
                    on: { assigned: _vm.AssignedMessages },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm.fields
        ? _c("b-table", {
            key: "inbox_" + _vm.redrawIndex,
            staticClass: "mt-2 ml-0 pl-0",
            attrs: {
              small: "",
              bordered: "",
              items: _vm.items,
              hover: "",
              selectable: "",
              "select-mode": "single",
              fields: _vm.fields,
              "tbody-tr-class": _vm.rowClass,
              busy: _vm.loading,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "head(removed)",
                  fn: function () {
                    return [
                      _vm.items.length != 0
                        ? _c("b-form-checkbox", {
                            on: { change: _vm.updateAll },
                            model: {
                              value: _vm.update_all,
                              callback: function ($$v) {
                                _vm.update_all = $$v
                              },
                              expression: "update_all",
                            },
                          })
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "cell(removed)",
                  fn: function (data) {
                    return [
                      _c("b-form-checkbox", {
                        attrs: {
                          name: "check-button",
                          value: data.item.message_uuid,
                        },
                        model: {
                          value: _vm.selected,
                          callback: function ($$v) {
                            _vm.selected = $$v
                          },
                          expression: "selected",
                        },
                      }),
                    ]
                  },
                },
                {
                  key: "cell(created_date)",
                  fn: function (data) {
                    return [
                      _c(
                        "div",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.onCellClick(data)
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.FormatDateTime(data.item.created_date))
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "cell(size)",
                  fn: function (data) {
                    return [
                      _c(
                        "div",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.onCellClick(data)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.bytesToSize(data.item.size)))]
                      ),
                    ]
                  },
                },
                {
                  key: "cell(from_email)",
                  fn: function (data) {
                    return [
                      _c(
                        "div",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.onCellClick(data)
                            },
                          },
                        },
                        [
                          data.item.message_type == "notification"
                            ? _c("span", [_vm._v("-")])
                            : _vm._e(),
                          data.item.message_type != "notification"
                            ? _c("span", [
                                data.item.from_name != ""
                                  ? _c("span", [
                                      _vm._v(_vm._s(data.item.from_name)),
                                      data.item.from_email != ""
                                        ? _c("span", [
                                            _vm._v(
                                              ", " +
                                                _vm._s(data.item.from_email)
                                            ),
                                          ])
                                        : _vm._e(),
                                    ])
                                  : _vm._e(),
                                data.item.from_name == ""
                                  ? _c("span", [
                                      _vm._v(_vm._s(data.item.from_email)),
                                    ])
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "cell(has_attachment)",
                  fn: function (data) {
                    return [
                      _c(
                        "div",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.onCellClick(data)
                            },
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "icon mr-1",
                            attrs: {
                              src: _vm.messageIcon(data.item.message_type),
                              alt: _vm.$t(
                                "MESSAGES.TYPE." + data.item.message_type
                              ),
                            },
                          }),
                          _c("MessageStatus", {
                            attrs: { status: data.item.status },
                          }),
                          _vm._v(" \n        "),
                          data.item.has_attachment
                            ? _c("i", { staticClass: "mr-1 fal fa-paperclip" })
                            : _vm._e(),
                          data.item.archived == 1 &&
                          _vm.functionbox_uuid &&
                          1 == 0
                            ? _c("i", { staticClass: "fal fa-times-circle" })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "cell(subject)",
                  fn: function (data) {
                    return [
                      _c(
                        "div",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.onCellClick(data)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "text-break" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(data.item.subject) +
                                "\n          "
                            ),
                          ]),
                          _c("div", { staticClass: "hidden-not-sm" }, [
                            _vm._v(
                              "\n            " + _vm._s(_vm.$t("FROM")) + " "
                            ),
                            data.item.message_type == "notification"
                              ? _c("span", [_vm._v("-")])
                              : _vm._e(),
                            data.item.message_type != "notification"
                              ? _c("span", [
                                  data.item.from_name != ""
                                    ? _c("span", [
                                        _vm._v(_vm._s(data.item.from_name)),
                                        data.item.from_email != ""
                                          ? _c("span", [
                                              _vm._v(
                                                ", " +
                                                  _vm._s(data.item.from_email)
                                              ),
                                            ])
                                          : _vm._e(),
                                      ])
                                    : _vm._e(),
                                  data.item.from_name == ""
                                    ? _c("span", [
                                        _vm._v(_vm._s(data.item.from_email)),
                                      ])
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                            _vm.functionbox_uuid && data.item.claimed
                              ? _c("div", [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("CLAIMED_BY")) +
                                      "  " +
                                      _vm._s(data.item.claimed) +
                                      "\n            "
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "cell(claimed)",
                  fn: function (data) {
                    return [
                      _c(
                        "div",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.onCellClick(data)
                            },
                          },
                        },
                        [_vm._v(_vm._s(data.item.claimed))]
                      ),
                    ]
                  },
                },
                {
                  key: "cell(conversation_id)",
                  fn: function (data) {
                    return [
                      _c(
                        "div",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.onCellClick(data)
                            },
                          },
                        },
                        [
                          data.item.claimed
                            ? _c("span", [
                                data.item.claimed == _vm.user.information.email
                                  ? _c("span", [
                                      _c("i", {
                                        staticClass: "fa-solid fa-circle green",
                                      }),
                                    ])
                                  : _vm._e(),
                                data.item.claimed != _vm.user.information.email
                                  ? _c("span", [
                                      _c("i", {
                                        staticClass:
                                          "fa-solid fa-triangle blue",
                                      }),
                                    ])
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "cell(to_email)",
                  fn: function (data) {
                    return [
                      _c(
                        "div",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.onCellClick(data)
                            },
                          },
                        },
                        [
                          data.item.claimed
                            ? _c("span", [
                                data.item.claimed == _vm.user.information.email
                                  ? _c("span", [
                                      _c("i", {
                                        staticClass: "fa-solid fa-circle green",
                                      }),
                                    ])
                                  : _vm._e(),
                                data.item.claimed != _vm.user.information.email
                                  ? _c("span", [
                                      _c("i", {
                                        staticClass:
                                          "fa-solid fa-triangle blue",
                                      }),
                                    ])
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "cell(id)",
                  fn: function (data) {
                    return [
                      _vm.hasBulk
                        ? _c("b-form-checkbox", {
                            attrs: {
                              name: "check-button",
                              value: data.item.message_uuid,
                            },
                            model: {
                              value: _vm.selected,
                              callback: function ($$v) {
                                _vm.selected = $$v
                              },
                              expression: "selected",
                            },
                          })
                        : _vm._e(),
                      _c(
                        "span",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.onCellClick(data)
                            },
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "icon mr-1",
                            attrs: {
                              src: _vm.messageIcon(data.item.message_type),
                              alt: _vm.$t(
                                "MESSAGES.TYPE." + data.item.message_type
                              ),
                            },
                          }),
                          _c("MessageStatus", {
                            attrs: { status: data.item.status },
                          }),
                          _vm._v(" \n        "),
                          data.item.has_attachment
                            ? _c("span", [
                                _c("i", { staticClass: "fal fa-paperclip" }),
                              ])
                            : _vm._e(),
                          _vm._v(
                            "\n        " +
                              _vm._s(data.item.subject) +
                              "\n        "
                          ),
                          _c("div", { staticClass: "time-information f12" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.FormatDateTime(data.item.created_date)
                                ) +
                                "\n        "
                            ),
                          ]),
                          _c("p", [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("FROM")) +
                                " " +
                                _vm._s(data.item.from_email) +
                                "\n        "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "table-busy",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "text-center my-2" },
                        [_c("b-spinner", { staticClass: "align-middle" })],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              3230914814
            ),
          })
        : _vm._e(),
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { cols: "12", md: "6" } }, [
            _vm.selected.length != 0
              ? _c(
                  "div",
                  [
                    _c(
                      "b-form",
                      { attrs: { inline: "" } },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: {
                              disabled: _vm.selected.length == 0,
                              variant: "danger",
                              title: _vm.$t("REMOVE"),
                            },
                            on: { click: _vm.removeMessages },
                          },
                          [_vm._v(_vm._s(_vm.$t("REMOVE")))]
                        ),
                        _vm.hasAssignOtherEnabled && _vm.functionbox_uuid != ""
                          ? _c("FunctionboxAssignUsers", {
                              attrs: {
                                functionbox_uuid: _vm.functionbox_uuid,
                                selected: _vm.selected,
                              },
                              on: { assigned: _vm.AssignedMessages },
                            })
                          : _vm._e(),
                        _vm.hasAssignOtherEnabled &&
                        _vm.functionbox_uuid != "" &&
                        _vm.hasClaimed
                          ? _c("FunctionboxAssignUsers", {
                              attrs: {
                                functionbox_uuid: _vm.functionbox_uuid,
                                selected: _vm.selected,
                                action: "clear",
                              },
                              on: { assigned: _vm.AssignedMessages },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _c(
            "b-col",
            { attrs: { cols: "12", md: "6" } },
            [
              _c("b-pagination", {
                staticClass: "mt-2",
                attrs: {
                  "total-rows": _vm.totalItems,
                  "per-page": _vm.limit,
                  align: "center",
                  pills: "",
                },
                on: { input: _vm.getInbox },
                model: {
                  value: _vm.currentPage,
                  callback: function ($$v) {
                    _vm.currentPage = $$v
                  },
                  expression: "currentPage",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }